import { Component, computed, input } from '@angular/core';
import { LocalePercentPipe } from 'src/app/core/pipes/locale-percent.pipe';
import { SharedModule } from 'src/app/core/shared.module';
import { MonitorAvailabilityStatistics } from 'src/app/models/monitor';
import { MonitorDisplayStatus } from '../monitor-global-status';
import { sliValueVariants } from './monitor-sli-value.variants';

@Component({
  selector: 'app-monitor-sli-value',
  templateUrl: './monitor-sli-value.component.html',
  imports: [SharedModule, LocalePercentPipe],
})
export class MonitorSliValueComponent {
  readonly stats = input<MonitorAvailabilityStatistics>();
  /** Colors the value by the monitor's live status instead of fixed
   *  thresholds, so it always agrees with the status label next to it. */
  readonly status = input<MonitorDisplayStatus>('UNKNOWN');

  readonly sli = computed<number | null>(() => {
    const stats = this.stats();
    if (!stats || stats.totalMonitoredSeconds === 0) {
      return null;
    }
    return stats.availabilityPercentage * 100;
  });

  readonly valueClasses = computed<string>(() => {
    const status = this.status();
    // A single-region outage colors the same red as a global one.
    if (status === 'DOWN' || status === 'DOWN_SINGLE_REGION') {
      return sliValueVariants({ status: 'DOWN' });
    }
    return sliValueVariants({
      status: status === 'DEGRADED' ? 'DEGRADED' : undefined,
    });
  });
}
